// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** @deprecated: this file is about to be removed */
.n-table-body + .n-table-body {
  border-top: 1px solid var(--color-border-subdued);
}
`, "",{"version":3,"sources":["webpack://./src/core-ui/components/table/TableBody/TableBody.less"],"names":[],"mappings":"AAAA,mDAAmD;AAGjD;EACE,iDAAA;AADJ","sourcesContent":["@import \"~neptune-core-ui/less/variables.less\";\n\n.n-table-body {\n  & + & {\n    border-top: @TableRow-border;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
